import { render } from "./EditModel.vue?vue&type=template&id=ccd41d0e"
import script from "./EditModel.vue?vue&type=script&lang=js"
export * from "./EditModel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__